/**
 * Mavenoid integration utilities
 */

const MAVENOID_CLIENT_ID = 'ma_85hocq4k9t_do936gsi31ak6qpeo3a433sgatofunptdv8s'
// const MAVENOID_CLIENT_ID = 'ma_78jq5nqeei_6igmj6668nugh44ucavl8bjajoh4g8078a61'
const MAVENOID_SCRIPT_URL = 'https://app.mavenoid.com/embedded/embedded.js'

/**
 * Load Mavenoid script if not already loaded
 * @returns {Promise<void>}
 */
export function loadMavenoid() {
  return new Promise((resolve) => {
    // Check if already loaded
    if (window.mavenoid) {
      resolve()
      return
    }

    // Create script element
    const script = document.createElement('script')
    script.async = true
    script.src = MAVENOID_SCRIPT_URL
    script.onload = () => {
      window.mavenoid = window.mavenoid || []
      resolve()
    }
    script.onerror = () => {
      console.error('Failed to load Mavenoid script')
      window.mavenoid = window.mavenoid || []
      resolve() // Resolve anyway to prevent blocking
    }
    
    document.head.appendChild(script)
  })
}

/**
 * Mount Mavenoid assistant with optional additional options
 * @param {Object} additionalOptions - Additional options to pass to Mavenoid mount
 */
export async function mountMavenoid(additionalOptions = {}) {
  if (!window.mavenoid) {
    await loadMavenoid()
  }

  const defaultOptions = {
    event: 'assistant-mount',
    clientId: MAVENOID_CLIENT_ID,
    onClose: () => unmountMavenoid()
  }

  // Merge default options with additional options
  const options = {
    ...defaultOptions,
    ...additionalOptions,
    // Preserve onClose callback if provided in additionalOptions
    onClose: () => {
      unmountMavenoid()
      if (additionalOptions.onClose) {
        additionalOptions.onClose()
      }
    }
  }

  window.mavenoid.push(options)
}

/**
 * Unmount Mavenoid assistant
 */
export function unmountMavenoid() {
  if (!window.mavenoid) {
    return
  }

  window.mavenoid.push({
    event: 'assistant-unmount'
  })
}

/**
 * Initialize Mavenoid and mount with options
 * @param {Object} options - Options to pass to mount
 * @returns {Promise<void>}
 */
export async function initAndMountMavenoid(options = {}) {
  await loadMavenoid()
  mountMavenoid(options)
}